import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-690254d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "term-edit-container" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "body-header" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = {
  key: 0,
  class: "table-wrap"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-padding" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TermEditHeader = _resolveComponent("TermEditHeader")!
  const _component_SchoolTypeTabs = _resolveComponent("SchoolTypeTabs")!
  const _component_AddYearButton = _resolveComponent("AddYearButton")!
  const _component_AddTermButton = _resolveComponent("AddTermButton")!
  const _component_TermEditTable = _resolveComponent("TermEditTable")!
  const _component_LoadingBlock = _resolveComponent("LoadingBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TermEditHeader, {
      class: "header",
      "is-admin": _ctx.isAdmin,
      editing: _ctx.editing,
      "on-click-edit": _ctx.startEditing,
      "on-click-cancel": _ctx.cancelEditing,
      "on-click-save": _ctx.save
    }, null, 8, ["is-admin", "editing", "on-click-edit", "on-click-cancel", "on-click-save"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SchoolTypeTabs, {
          class: "tabs",
          "change-tab": _ctx.changeTab,
          "current-tab": _ctx.currentTab,
          enabled: !_ctx.editing
        }, null, 8, ["change-tab", "current-tab", "enabled"]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_AddYearButton, {
                key: 0,
                class: "button",
                "on-click": _ctx.addSchoolYear
              }, null, 8, ["on-click"]))
            : _createCommentVNode("", true),
          (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_AddTermButton, {
                key: 1,
                class: "button",
                "on-click": _ctx.addTermNumber
              }, null, 8, ["on-click"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.tableModel != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(), _createBlock(_component_TermEditTable, {
              key: _ctx.currentTab,
              class: "table",
              model: _ctx.tableModel,
              "on-change-term": _ctx.onChangeTermInternal,
              "max-term-number": _ctx.maxTermNumber,
              "min-school-year": _ctx.minSchoolYear,
              "max-school-year": _ctx.maxSchoolYear,
              "delete-term-number": _ctx.deleteTermNumber,
              "delete-school-year": _ctx.deleteSchoolYear,
              editing: _ctx.editing
            }, null, 8, ["model", "on-change-term", "max-term-number", "min-school-year", "max-school-year", "delete-term-number", "delete-school-year", "editing"])),
            _hoisted_6
          ]))
        : (_openBlock(), _createBlock(_component_LoadingBlock, { key: 1 }))
    ])
  ]))
}